// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-119e3b84] button.no-caret:after{display:none!important}.dropdown-menu-right[data-v-119e3b84]{right:0;left:auto}", ""]);
// Exports
module.exports = exports;
